
import { getPercentage } from "@/helpers";
import { defineComponent, computed, ref } from "vue";

import { Answer, questions } from "@/data/questions";

import PlusMinusScorer from "@/components/PlusMinusScorer.vue";

export default defineComponent({
  name: "InfoGrid",
  components: {
    plusMinus: PlusMinusScorer,
  },
  props: {
    answers: {
      type: Array,
      required: true,
    },
    selected: {
      type: Answer,
      required: true,
    },
  },
  setup(props) {
    const selectedAnswer = ref();
    const ans = props.answers as Answer[];
    return { ans, selectedAnswer };
  },
});
